export enum ESelecaoItemSincronizarAmbiente {
    Todos = 1,
    ItensEspecificos = 2,
}
